export default {
      id: "ind-bang-usage",
      viewBox: "0 0 25 25",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#ind-bang",
      toString: function () {
        return this.url;
      }
    }